"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var emptyFolderOperation_1 = require("owa-service/lib/operation/emptyFolderOperation");
var emptyFolderRequest_1 = require("owa-service/lib/factory/emptyFolderRequest");
var folderId_1 = require("owa-service/lib/factory/folderId");
var distinguishedFolderId_1 = require("owa-service/lib/factory/distinguishedFolderId");
/* tslint:disable:restrict-import-path */
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
/* tslint:enable:restrict-import-path */
var isSharedFolder_1 = require("owa-mail-store/lib/utils/isSharedFolder");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
var folderIdToName_1 = require("owa-session-store/lib/utils/folderIdToName");
var itemId_1 = require("owa-service/lib/factory/itemId");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
/**
 * Create and submit the empty folder action for the specified folder
 * @param folder the folder to be emptied
 * @param disposalType the disposal type
 * @param deleteSubFolder whether to delete subfolder
 * @param clientLastSyncTime the client last sync time watermark
 * @param itemIdsToExclude item ids to exclude from empty folder operation
 */
function emptyFolderService(folder, disposalType, deleteSubFolder, clientLastSyncTime, itemIdsToExclude) {
    var requestBody = configureRequestBody(folder, disposalType, deleteSubFolder, clientLastSyncTime, itemIdsToExclude);
    return emptyFolderOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.emptyFolderService = emptyFolderService;
/**
 * Configure the empty folder request body
 * @param folder the folder to be emptied
 * @param disposalType the disposal type
 * @param deleteSubFolder whether to delete subfolder
 * @param clientLastSyncTime the client last sync time watermark
 * @param itemIdsToExclude item ids to exclude from empty folder operation
 */
function configureRequestBody(folder, disposalType, deleteSubFolder, clientLastSyncTime, itemIdsToExclude) {
    var folderIdToEmpty = null;
    var distinguishedFolderIdName = folderIdToName_1.default(folder.FolderId.Id);
    folderIdToEmpty =
        distinguishedFolderIdName == 'none'
            ? folderId_1.default({ Id: folder.FolderId.Id })
            : distinguishedFolderId_1.default({ Id: distinguishedFolderIdName });
    var baseItemIds = itemIdsToExclude != undefined ? itemIdsToExclude.map(function (id) { return itemId_1.default({ Id: id }); }) : undefined;
    var body = emptyFolderRequest_1.default({
        FolderIds: [folderIdToEmpty],
        AllowSearchFolder: true,
        DeleteType: disposalType,
        DeleteSubFolders: deleteSubFolder,
        SuppressReadReceipt: getUserConfiguration_1.default().UserOptions.ReadReceipt != 'AlwaysSend' ||
            isSharedFolder_1.default(folder.FolderId.Id),
        ItemIdsToExclude: baseItemIds,
        BulkActionRequest: owa_mail_feature_flags_1.isMailFeatureEnabled('tri-bulkActionNotification'),
    });
    // Server does not support specify ClientLastSyncTime and deleting subfolders at the same time
    if (deleteSubFolder && clientLastSyncTime) {
        throw new Error('ClientLastSyncTime is not supported when deleting subfolders.');
    }
    // Specify ClientLastSyncTime if not delete sub folders
    if (!deleteSubFolder) {
        body.ClientLastSyncTime = clientLastSyncTime && clientLastSyncTime.toISOString();
    }
    return body;
}
//# sourceMappingURL=emptyFolderService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/emptyFolderService.js
// module id = 5648
// module chunks = 62